<template>
<svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Male`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_461367052c__clip0_515_1435)"><circle cx="8.5" cy="8.5" r="8.5" :fill="useCurrentColor ? 'currentColor' : '#3681EE'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2648 3.83208C13.2129 3.8229 13.1599 3.82129 13.1076 3.82726L11.0217 3.83008C10.7328 3.83047 10.4989 4.06497 10.4993 4.35385C10.4997 4.64273 10.7342 4.8766 11.0231 4.87621L11.8875 4.87504L10.5767 6.17725C9.87823 5.5179 8.93632 5.1137 7.9 5.1137C5.74609 5.1137 4 6.85979 4 9.0137C4 11.1676 5.74609 12.9137 7.9 12.9137C10.0539 12.9137 11.8 11.1676 11.8 9.0137C11.8 8.28955 11.6026 7.6115 11.2588 7.0304L12.7039 5.59481L12.7043 6.38535C12.7045 6.66292 12.9297 6.88781 13.2072 6.88764C13.4848 6.88747 13.7097 6.66232 13.7095 6.38474L13.7084 4.43487C13.7148 4.38351 13.7139 4.33141 13.7057 4.28024C13.6821 4.04606 13.4978 3.85936 13.2648 3.83208ZM10.6643 9.04287C10.6643 10.5617 9.43311 11.7929 7.91433 11.7929C6.39555 11.7929 5.16433 10.5617 5.16433 9.04287C5.16433 7.52409 6.39555 6.29287 7.91433 6.29287C9.43311 6.29287 10.6643 7.52409 10.6643 9.04287Z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></g><defs><clipPath id="svg_461367052c__clip0_515_1435"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" d="M0 0H17V17H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconMale',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
